module.exports = __webpack_public_path__ + "img/noti_lite_logo.1980f873.png";